import { addressToLocations } from "@arcgis/core/rest/locator"

import type { LocationCandidate } from "./types"
import { LOCATOR_URL, MIN_SCORE } from "./constants"

function locatorResult_isPointAddress(result: LocationCandidate): boolean {
  return result.type === 'PointAddress'
}

function locatorResults_compare(a: LocationCandidate, b: LocationCandidate): number {
  if (a.score === b.score) {
    if (locatorResult_isPointAddress(a)) return 1
    if (locatorResult_isPointAddress(b)) return -1
    return 0
  }
  return a.score > b.score ? -1 : 1
}

function locatorResults_equal(a: LocationCandidate, b: LocationCandidate): boolean {
  return (
    a.street === b.street &&
    a.city === b.city &&
    a.streetSuffix === b.streetSuffix &&
    a.streetPrefix === b.streetPrefix &&
    a.zipcode === b.zipcode
  )
}

function addressCandidateToLocationCandidate(candidate: __esri.AddressCandidate): LocationCandidate {
  return {
    label: candidate.address,
    type: candidate.attributes.Addr_type,
    score: candidate.score,
    location: candidate.location,
    street: candidate.attributes.StreetName,
    streetSuffix: candidate.attributes.SufType,
    streetPrefix: candidate.attributes.PreDir,
    city: candidate.attributes.City,
    zipcode: candidate.attributes.ZIP,
  }
}


export const searchLocator = async (address: string): Promise<LocationCandidate[]> => {
  const response: __esri.AddressCandidate[] = await addressToLocations(LOCATOR_URL, {
    address: {
      SingleLine: address,
    },
    outFields: [
      'Addr_type',
      'City',
      'StreetName',
      'SufType',
      'PreDir',
      'ZIP',
    ],
  })

  let results: LocationCandidate[] = response.map(addressCandidateToLocationCandidate)
  const hasMatch = results.some(function (r) {
    return r.score >= MIN_SCORE
  })
  if (hasMatch) {
    results = results.filter(function (r) {
      return r.score >= MIN_SCORE
    })
  }

  results.sort(locatorResults_compare)

  var uniqueResults = results.filter(locatorResult_isPointAddress)
  results.forEach(function (r) {
    var isPointAddress = locatorResult_isPointAddress(r)
    if (isPointAddress) return
    var alreadyInResults = uniqueResults.some(function (filteredResult) {
      return locatorResults_equal(r, filteredResult)
    })
    if (!alreadyInResults) {
      uniqueResults.push(r)
    }
  })

  return uniqueResults.sort(locatorResults_compare)
}
